<ng-container *transloco="let t;">
  <p-dialog *ngIf="candidate !== null" visible="true" [header]="t('ac_persons.move_to_other_ac')" [draggable]="false" [modal]="true" [closable]="false" [appendTo]="'body'">
    <app-loader [loading]="loading"></app-loader>
    <ng-container *ngIf="loading === false">

      <div class="p-d-flex p-ai-center p-mt-4 p-mb-4" *ngIf="acs.length === 0">
        <div class="p-mr-2">
          <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
        </div>
        <div>
          {{ t('ac_persons.no_acs_found') }}
        </div>
      </div>

      <ng-container *ngIf="acs.length > 0">
        <p>{{ t('ac_persons.ac_to_move', { name: candidate.fullname }) }}</p>
        <p-table [value]="acs" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th style="min-width: 40px;"></th>
              <th>{{ t('common.labels.ac') }}</th>
              <th>{{ t('common.labels.date') }}</th>
              <th>{{ t('common.labels.candidates') }}</th>
              <th>{{ t('common.labels.status') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-ac>
            <tr (click)="selectAc(ac)" (keyup.enter)="selectAc(ac)" class="pointer" [class.selected]="ac === selected" role="link" tabindex="0">
              <td>
                <i *ngIf="ac !== selected" class="pi pi-stop"></i>
                <i *ngIf="ac === selected" class="pi pi-check"></i>
              </td>
              <td>{{ac.name}} {{ ac.ordernumber }}</td>
              <td>
                <span>{{ac.start_time | amDateFormat: 'DD.MM.YYYY hh:mm'}} {{ t('common.labels.oclock') }}</span>
              </td>
              <td>
                <span *ngFor="let candidate of ac.candidates">
                  {{candidate.fullname}}<br>
                </span>
              </td>
              <td>
                <span>{{ t(ac.getStatusName()) }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>

    </ng-container>
    <p-footer>
      <div class="p-text-right">
        <button pButton (click)="onCancel()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary"></button>
        <button *ngIf="acs.length > 0 && selected !== null" pButton (click)="onMove()" type="button" label="{{ t('common.labels.move') }}" class="p-ml-2"></button>
      </div>
    </p-footer>
  </p-dialog>
</ng-container>
